class CustomSlider extends HTMLElement {
    constructor() {
        super();
        this.id = this.getAttribute('id');
        this.perPage = this.dataset.perPage;
        this.perMove = this.dataset.perMove;
        this.paddingRight = this.dataset.paddingRight;
        this.rewind = this.dataset.rewind;
        this.gap = this.dataset.gap;
        this.arrows = this.dataset.arrows;
        this.pagination = this.dataset.pagination;
    }
    connectedCallback() {
        const splide = new Splide(`#${this.id}`, {
            type: 'splide',
            perPage: this.perPage,
            perMove: this.perMove,
            padding: {
                right: this.paddingRight
            },
            rewind: this.rewind,
            gap: this.gap,
            arrows: false,
            pagination: false,
            breakpoints: {
                749: {
                    arrows: false,
                    pagination: false,
                    perPage: 1,
                    gap: '10px',
                    padding : {
                        right: '15%'
                    }
                }
            },
        }).mount();
        const prevArrow = document.querySelector('.splide__arrow--prev');
        const nextArrow = document.querySelector('.splide__arrow--next');

        // Hide the previous arrow on initial load

        if(prevArrow){
            prevArrow.style.display = 'none';
        }
        if(prevArrow && nextArrow){
        splide.on('moved', function () {
            if (splide.index === 0) {
                prevArrow.style.display = 'none';
                nextArrow.style.display = 'block';
                splide.refresh();
            } else if (splide.index === splide.length - 1) {
                prevArrow.style.display = 'block';
                nextArrow.style.display = 'none';
                splide.refresh();
            } else {
                prevArrow.style.display = 'block';
                nextArrow.style.display = 'block';
                splide.refresh();
            }
        });
    }
}
}
customElements.define('custom-slider', CustomSlider);